module.exports = __webpack_public_path__ + "static/assets/35c6e0b518730b9af818f687364ab222.png";